<div class="card title-card mb-4">
  <div class="flex align-items-center">
    <i class="pi mr-1 title-card-icon" [class.pi-plus-circle]="mode === 'create'" [class.pi-pencil]="mode === 'edit'"></i>
    <p class="mb-0 text-3xl title">
      {{(mode == 'create' ? 'misc.creation.defaultAssetRepresentation' : 'misc.edition.defaultAssetRepresentation') | transloco | capitalize}}
    </p>
  </div>
</div>
<div class="card step-card flex flex-column">
  <form [formGroup]="representationForm" *ngIf="representationForm">
    <div class="grid">

      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="name">{{'attribute.name' | transloco}} (*)</label>
        </div>
        <div class="col-12">
          <input pInputText id="name" type="text" formControlName="name" class="w-full">
        </div>
        <app-validation-errors [control]="representationForm.get('name')"></app-validation-errors>
      </div>

      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="description">{{'attribute.description' | transloco}}</label>
        </div>
        <div class="col-12">
          <input pInputText id="description" type="text" formControlName="description" class="w-full">
        </div>
        <app-validation-errors [control]="representationForm.get('description')"></app-validation-errors>
      </div>

      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label>{{'attribute.icon' | transloco}}</label>
        </div>
        <div class="col-12 flex flex-column">
          <div class="mb-2">
            <label class="cursor-pointer p-button mr-2" pRipple>
              {{'primeng.upload' | transloco}}<i class="pi pi-upload ml-2" style="font-size: 14px;"></i>
              <input #imageInput type="file" accept="image/*" (change)="onUploadIcon(imageInput)" class="hidden">
            </label>
          </div>
          <div>
            <img *ngIf="icon" [src]="icon" style="max-height: 150px;" [alt]="'attribute.icon' | transloco">
          </div>
        </div>
      </div>

    </div>
  </form>
  <div class="mt-auto">
    <div class="flex justify-content-between mt-4">
      <button
        [label]="'common.cancel' | transloco"
        (click)="cancel()"
        pButton
        class="p-button-danger ml-2"
        iconPos="right"
      ></button>
      <p-button
        *ngIf="representationForm"
        [label]="(mode == 'creation' ? 'common.create' : 'common.save') | transloco"
        [disabled]="!representationForm.valid"
        [loading]="persistingChanges"
        (onClick)="persistRepresentationData()"
        styleClass="p-button-primary"
        class="mr-2"
      ></p-button>
    </div>
  </div>
</div>
